module.exports = __webpack_public_path__ + "img/card-zhifubao.746d1d15.png";